import {
    THEME_ID,
    createTheme,
    ThemeProvider,
} from '@mui/material/styles';
import { defaultTheme } from 'react-admin';

const materialTheme = createTheme({
    ...defaultTheme,
    components: {
        ...defaultTheme.components,
        MuiToolbar: {
            styleOverrides: {
                root: ({ theme }) => ({
                    '&.RaBulkActionsToolbar-toolbar': {
                        backgroundColor:
                            theme.palette.mode === 'dark'
                                ? 'rgb(66, 165, 245)'
                                : 'rgb(217, 237, 253)',
                        color: theme.palette.text.primary,
                        // Targeting MuiTypography-subtitle1 inside RaBulkActionsToolbar
                        '& .MuiTypography-subtitle1,& .MuiSvgIcon-fontSizeSmall': {
                            color: theme.palette.mode === 'dark' ? 'white' : 'rgb(25, 118, 210)'
                        }
                    },
                }),
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                columnHeaderRow: ({ theme }) => ({
                    ...(theme.palette.mode === 'dark' && {
                        backgroundColor: 'rgb(56, 56, 56) !important',
                    }),
                })
            },
        },
    },
    //Toggling dark mode manually
    // https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually
    colorSchemes: { light: true, dark: true },
    cssVariables: {
        colorSchemeSelector: 'class'
    },
});

export {
    THEME_ID as MATERIAL_THEME_ID,
    materialTheme as MATERIAL_THEME,
    ThemeProvider as MaterialCssVarsProvider,
};